jQuery(function ($) {
	const selector =
		'.gfield--type-fileupload input[type="file"], .gfield--input-type-fileupload input[type="file"]';

	function getStatusEl($field) {
		let $status = $field.children('.gform-fileupload-selected');

		if (!$status.length) {
			$status = $(
				'<div class="gform-fileupload-selected" aria-live="polite"></div>'
			);
			$field.append($status);
		}

		return $status;
	}

	function updateFileStatus(input) {
		const $field = $(input).closest(
			'.gfield--type-fileupload, .gfield--input-type-fileupload'
		);
		const $container = $field.find('.ginput_container_fileupload');
		const $previewList = $container.find('.ginput_preview_list');
		const $status = getStatusEl($field);
		const file = input.files && input.files[0];

		$container.find('.gform-fileupload-selected').remove();

		if ($previewList.length && $previewList.children().length) {
			$status.empty();
			$field.addClass('has-file');
			return;
		}

		if (file) {
			$status.html(
				'<button type="button" class="gform-fileupload-remove" aria-label="Remove file">' +
					'<span aria-hidden="true">&times;</span>' +
					'</button>' +
					'<div class="gform-fileupload-selected__body">' +
					'<span class="gform-fileupload-selected__label">Selected file</span>' +
					'<span class="gform-fileupload-selected__name"></span>' +
					'</div>'
			);
			$status.find('.gform-fileupload-selected__name').text(file.name);
			$field.addClass('has-file');
			return;
		}

		$status.empty();
		$field.removeClass('has-file');
	}

	$(document).on('change', selector, function () {
		updateFileStatus(this);
	});

	$(document).on('click', '.gform-fileupload-remove', function (event) {
		event.preventDefault();

		const $field = $(this).closest(
			'.gfield--type-fileupload, .gfield--input-type-fileupload'
		);
		const input = $field.find('input[type="file"]')[0];

		if (!input) {
			return;
		}

		input.value = '';

		try {
			input.files = new DataTransfer().files;
		} catch (error) {
			// Some browsers only support clearing via value.
		}

		$(input).trigger('change');
	});

	$(document).on(
		'click',
		'.gform_delete_file, .gfield_fileupload_cancel',
		function () {
			const $field = $(this).closest(
				'.gfield--type-fileupload, .gfield--input-type-fileupload'
			);
			const $input = $field.find('input[type="file"]');

			window.setTimeout(function () {
				if ($input.length) {
					updateFileStatus($input[0]);
				}
			}, 50);
		}
	);

	$(document).on(
		'gform_post_render gform_confirmation_loaded',
		function () {
			$(selector).each(function () {
				updateFileStatus(this);
			});
		}
	);

	$(selector).each(function () {
		updateFileStatus(this);
	});
});
